import { LeftOutlined } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import { useNavigate } from 'react-router-dom'

import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { ClassifiersDetails } from '../components'

export const ClassifiersDetailsPage = () => {
  const { t } = useLocales()
  const navigate = useNavigate()

  const onBackClick = () => {
    navigate(paths.classifiers.root)
  }

  return (
    <PageBreadcrumbs
      title={t('classifiers.classifiers')}
      items={[{ title: t('classifiers.classifiers') }]}
    >
      <Flex vertical gap={24}>
        <Button
          icon={<LeftOutlined />}
          className="fit-content"
          onClick={onBackClick}
        >
          {t('common.back')}
        </Button>

        <ClassifiersDetails />
      </Flex>
    </PageBreadcrumbs>
  )
}
